"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const use_carousel_1 = require("./use-carousel");
// The wordmark is the only thing naming the category, so it needs an accessible name.
// Spelled as the artwork reads — the ids are only sprite filenames.
const logoLabels = {
    'fortune-500': 'Fortune 500',
    'managed-service-providers': 'Managed Service Providers',
    'cybersecurity-vendors': 'Cybersecurity Vendors',
    'professional-services': 'Professional Services',
    'government-and-defense': 'Government & Defence',
    'technology-sector': 'Technology Sector',
    'pharmaceuticals-and-life-sciences': 'Pharmaceuticals & Life Sciences',
    'aerospace-and-defense': 'Aerospace & Defence',
    'legal-services': 'Legal Services',
    'critical-infrastructure': 'Critical Infrastructure',
    'financial-services': 'Financial Services',
    'energy-and-utilities': 'Energy & Utilities',
    telecommunications: 'Telecommunications',
    'public-sector': 'Public Sector',
    'higher-education': 'Higher Education',
};
const Logo = ({ logo }) => {
    var _a;
    const [staticData] = (0, ui_1.useStaticState)();
    const src = (_a = staticData === null || staticData === void 0 ? void 0 : staticData.manifest) === null || _a === void 0 ? void 0 : _a['assets/logo-sprite.svg'];
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledLogo, { role: "img", "aria-label": logoLabels[logo], "data-testid": `${logo}-logo`, children: (0, jsx_runtime_1.jsx)("use", { href: `${src}#${logo}` }) }));
};
const Item = ({ item, isClone }) => ((0, jsx_runtime_1.jsxs)(styled_1.StyledItem, { "aria-hidden": isClone, children: [(0, jsx_runtime_1.jsxs)(styled_1.StyledItemHeading, { children: [item.heading, !!item.headingNote && (0, jsx_runtime_1.jsx)(styled_1.StyledItemHeadingNote, { children: item.headingNote })] }), (0, jsx_runtime_1.jsx)(Logo, { logo: item.logo }), (0, jsx_runtime_1.jsx)(styled_1.StyledItemDescription, { children: item.description })] }));
const SocialProofCarousel = ({ title, items }) => {
    const { canScroll, offset, isAnimated, pause, resume } = (0, use_carousel_1.useCarousel)({ itemCount: items.length });
    // A second copy fills the gap past the end of the list; index === items.length is
    // pixel-identical to index === 0, which is what makes the wrap invisible
    const trackItems = canScroll ? [...items, ...items] : items;
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledViewport, { role: "region", "aria-roledescription": "carousel", "aria-label": title, onMouseEnter: pause, onMouseLeave: resume, onFocusCapture: pause, onBlurCapture: resume, children: (0, jsx_runtime_1.jsx)(styled_1.StyledTrack, { "$offset": offset, "$isAnimated": isAnimated, "$itemCount": items.length, "data-testid": "social-proof-track", children: trackItems.map((item, index) => {
                const isClone = index >= items.length;
                return (0, jsx_runtime_1.jsx)(Item, { item: item, isClone: isClone }, isClone ? `${item.id}-clone` : item.id);
            }) }) }));
};
exports.default = SocialProofCarousel;
